export default __webpack_public_path__ + "static/media/special-kitchen.1b712ba5.jpg";